import { Input } from 'common/components/Forms/Inputs/Input'
import { Dispatch, SetStateAction } from 'react'
import styled from 'styled-components'
import { IJobsListQuery } from './CommunityJobs'
import { CommunityJobsBaseFilters } from './CommunityJobsBaseFilters'
interface IProps {
  query: IJobsListQuery
  setQuery: Dispatch<SetStateAction<IJobsListQuery>>
}
export const CommunityJobsFilters = ({ query, setQuery }: IProps) => {
  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => setQuery((c) => ({ ...c, search: e.target.value }))

  return (
    <Div className="flex flex-column gap-3">
      <Input
        value={query.search || ''}
        icon="pi pi-search"
        onChange={onSearch}
        placeholder="Search by job title, position or company"
      />

      <CommunityJobsBaseFilters query={query} setQuery={setQuery} />
    </Div>
  )
}

export const Div = styled.div``
